export default {
  SET_AUTH_USER: 'SET_AUTH_USER',
  SET_ERROR: 'SET_ERROR',
  SET_LOADING: 'SET_LOADING'
};
